module.exports = "mutation($key: Int!) {\n    checkMJKey(key: $key)\n}\n"